import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { AdAuditEntry } from '../../marketing-review-interfaces/marketing-review.interface';

/** What the dashboard hands the dialog when it opens. */
export interface AuditLogDialogData {
    referenceNo: string;
    title: string;
    submitter: string;
    entries: AdAuditEntry[];
}

/**
 * Audit log overlay — the immutable activity trail for one advertisement, newest first.
 *
 * Opened from the dashboard's per-submitter action column.
 */
@Component({
    selector: 'app-audit-log-dialog',
    imports: [CommonModule, MatIconModule],
    templateUrl: './audit-log-dialog.component.html',
    styleUrl: './audit-log-dialog.component.scss'
})
export class AuditLogDialogComponent {

    private dialogRef = inject(MatDialogRef<AuditLogDialogComponent>);
    protected data = inject<AuditLogDialogData>(MAT_DIALOG_DATA);

    protected close(): void {
        this.dialogRef.close();
    }
}
